import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Check } from "lucide-react";
import { api } from "@/lib/api";

export default function PackagesPage() {
  const [pkgs, setPkgs] = useState([]);
  useEffect(() => {
    api.get("/packages").then((r) => setPkgs(r.data)).catch(() => {});
  }, []);

  return (
    <div className="pt-32" data-testid="packages-page">
      <header className="max-w-7xl mx-auto px-6 md:px-10 pt-8 pb-16">
        <div className="overline text-primary/80">Our packages</div>
        <h1 className="mt-4 font-display text-5xl md:text-7xl leading-[1.05]">Craft the evening.</h1>
        <p className="mt-6 text-muted-foreground text-lg max-w-2xl">
          Three signature experiences. Every one fully customisable — from the cocktail menu to the glassware.
        </p>
      </header>

      <section className="max-w-7xl mx-auto px-6 md:px-10 pb-24 space-y-10">
        {pkgs.map((p, idx) => (
          <article
            key={p.id}
            className={`grid md:grid-cols-2 gap-10 items-center border-b border-white/8 pb-14 last:border-0 ${
              idx % 2 === 1 ? "md:[&>*:first-child]:order-2" : ""
            }`}
            data-testid={`package-row-${p.id}`}
          >
            <div className="rounded-2xl overflow-hidden aspect-[4/3]">
              <img src={p.image_url} alt={p.name} className="w-full h-full object-cover" />
            </div>
            <div>
              {p.is_featured && (
                <span className="inline-block overline px-3 py-1 rounded-full bg-primary/15 text-primary border border-primary/30">
                  Most booked
                </span>
              )}
              <div className="overline text-primary/80 mt-4">{p.tagline}</div>
              <h2 className="mt-3 font-display text-4xl md:text-5xl">{p.name}</h2>
              <p className="mt-5 text-muted-foreground leading-relaxed max-w-lg">{p.description}</p>

              <ul className="mt-8 space-y-3">
                {(p.features || []).map((f) => (
                  <li key={f} className="flex items-start gap-3 text-sm">
                    <Check size={16} className="text-primary mt-0.5" />
                    <span>{f}</span>
                  </li>
                ))}
              </ul>

              <div className="mt-10 flex items-end justify-between max-w-md">
                <div>
                  <div className="font-display text-4xl">£{p.price}</div>
                  <div className="overline text-muted-foreground mt-1">{p.duration_hours} hrs · {p.guest_count}</div>
                </div>
                <Link
                  to={`/book?package=${p.id}`}
                  data-testid={`packages-page-book-${p.id}`}
                  className="rounded-full px-6 py-3 text-sm tracking-wide bg-primary text-primary-foreground hover:bg-primary/90 transition-colors"
                >
                  Book this
                </Link>
              </div>
            </div>
          </article>
        ))}
      </section>
    </div>
  );
}
